import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import AccountTab from '../../tabs/settings/AccountTab/AccountTab';
import AppearanceTab from '../../tabs/settings/AppearanceTab/AppearanceTab';
import IntegrationsTab from '../../tabs/settings/IntegrationsTab/IntegrationsTab';

const styles = (theme) => ({
  container: {
    maxWidth: 600,
    margin: '0 auto',
    marginTop: theme.spacing(12),
  },
  tabs: {
    marginBottom: theme.spacing(1)
  },
  closeButton: {
    marginRight: theme.spacing(2),
  },
});

class Settings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedTab: 0
    };
  }

  changeTab = (event, value) => {
    this.setState({
      selectedTab: value
    });
  };

  render() {
    // Styling
    const { classes } = this.props;

    // Properties
    const {
      user,
      isPerformingAuthAction,
      onUpgradeClick,
      onExtendClick,
    } = this.props;

    const { onEnablePasswordLogin } = this.props;

    // Events
    const {
      onCancelSubscriptionClick,
      getSubscription,
      getSubscriptionCurrentPeriodEnd,
    } = this.props;

    const { layoutDirection, onLayoutDirectionChange } = this.props;

    const { selectedTab } = this.state;

    return (
      <div className={classes.container}>
        <Tabs
          className={classes.tabs}
          indicatorColor="primary"
          textColor="primary"
          onChange={this.changeTab}
          value={selectedTab}
          variant="fullWidth"
        >
          <Tab label="Account" />
          <Tab label="Appearance" />
          <Tab label="Integrations" />
        </Tabs>

        {selectedTab === 0 &&
        <AccountTab
          user={user}
          isPerformingAuthAction={isPerformingAuthAction}
          onCancelSubscriptionClick={onCancelSubscriptionClick}
          getSubscription={getSubscription}
          getSubscriptionCurrentPeriodEnd={getSubscriptionCurrentPeriodEnd}
          onUpgradeClick={onUpgradeClick}
          onExtendClick={onExtendClick}
          onEnablePasswordLogin={onEnablePasswordLogin}
        />
        }
        {selectedTab === 1 &&
        <AppearanceTab
          user={user}
          isPerformingAuthAction={isPerformingAuthAction}
          layoutDirection={layoutDirection}
          onLayoutDirectionChange={onLayoutDirectionChange}
        />
        }
        {selectedTab === 2 &&
        <IntegrationsTab
          user={user}
          isPerformingAuthAction={isPerformingAuthAction}
        />
        }
    </div>
    );
  }
}

Settings.propTypes = {
  classes: PropTypes.object.isRequired,

  user: PropTypes.object.isRequired,
  isPerformingAuthAction: PropTypes.bool.isRequired,

  onUpgradeClick: PropTypes.func.isRequired,
  onExtendClick: PropTypes.func.isRequired,
  onCancelSubscriptionClick: PropTypes.func.isRequired,
  getSubscription: PropTypes.func.isRequired,
};

export default withStyles(styles)(Settings);
